<template>
  <keep-alive>
    <router-view />
  </keep-alive>
</template>

<script>
import { getExploreName } from "@/utils/userAgent.js";
import { watch, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    document.title = route.meta.title;

    watch(route, (route) => {
      document.title = route.meta.title;
    });

    // 初始换配置参数
    const getQueryString = (name) => {
      let reg = new RegExp("([?|&])" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.href.match(reg);
      if (r != null) {
        return unescape(decodeURI(r[2]));
      }
    };

    // 小程序 onShow 刷新标志
    const refreshTimestamp = () => {
      let timeStamp = getQueryString("timeStamp");
      if (timeStamp) {
        store.commit("setFreshTimestamp", timeStamp);
      }
    };
    let refreshTimer = null;
    onMounted(() => {
      console.log('location',window.location)
      console.log('getQueryString("classId")',getQueryString("classId"))
      refreshTimer = setInterval(() => {
        refreshTimestamp();
      }, 1000);
    });
    onUnmounted(() => {
      clearInterval(refreshTimer);
    });

    const initRouteParams = () => {
      store.commit("setExploreName", getExploreName());
      store.commit("setToken", getQueryString("token"));
      store.commit("setClassId", getQueryString("classId"));
      store.commit("setSchoolCode", getQueryString("schoolCode"));
      store.commit(
        "setSchoolName",
        decodeURI(getQueryString("schoolName") || "")
      );
      store.commit("setUserType", getQueryString("userType"));
      store.commit(
        "setUserName",
        decodeURI(getQueryString("userName") || "") ||
          localStorage.getItem("userName")
      );

      store.commit(
        "setStudentUserIndex",
        decodeURI(getQueryString("studentUserIndex") || "") ||
          localStorage.getItem("studentUserIndex")
      );
      store.commit(
        "setStudentName",
        decodeURI(getQueryString("studentName") || "") ||
          localStorage.getItem("studentName")
      );
      store.commit(
        "setStudentUserId",
        decodeURI(getQueryString("studentUserId") || "") ||
          localStorage.getItem("studentUserId")
      );

      store.commit(
        "setUserIndex",
        decodeURI(getQueryString("userIndex") || "") ||
          localStorage.getItem("userIndex")
      );
     
      store.commit(
        "setPhone",
        decodeURI(getQueryString("phone") || "") ||
          localStorage.getItem("phone")
      );
      store.commit(
        "setUserId",
        decodeURI(getQueryString("userId") || "") ||
          localStorage.getItem("userId")
      );
    };
    initRouteParams();
  },
  mounted() {
    const hash = window.location.hash;
    const index = hash.indexOf("?");
    const bizType = this.getQueryString(hash.slice(index), "bizType");
    console.log("bizType", bizType);
    window.sessionStorage.setItem("bizType", bizType);
  },
  methods: {
    getQueryString: (search, name) => {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      }
      return null;
    }
  }

};
</script>

<style lang="less">
@import url("~@/assets/style/custom-style.less");
</style>
